import { StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import { OTP_CONTACT_ID, OTP_CONTACT_METHOD } from '../otp/otp-util';
import { Injectable } from '@angular/core';

@Injectable()
export class OrderEmailAndPhoneBehavior extends StrictBehavior {
  constructor() {
    super();
  }
  async executeBehavior(
    args: { mobilePhoneRowId: string; emailRowId: string },
    ctx: BehaviorContext
  ): Promise<any> {
    const contactMethod = ctx.get(OTP_CONTACT_METHOD);
    const mobilePhoneRowFactory = ctx.getFactoryById(args.mobilePhoneRowId);
    const emailRowFactory = ctx.getFactoryById(args.emailRowId);

    // Phone
    if (contactMethod === 0) {
      mobilePhoneRowFactory.model.order = 1;
      emailRowFactory.model.order = 2;

      //Email
    } else if (contactMethod === 1) {
      emailRowFactory.model.order = 1;
      mobilePhoneRowFactory.model.order = 2;
    }
  }
}
